/**
 * MissionDetailPanel
 *
 * Extracted from MissionRegistryView — renders the full-page mission detail view
 * when a mission is selected. All state and callbacks are passed from the parent.
 *
 * NOTE: This component is intentionally "fat" in props to preserve all existing
 * functionality without refactoring the internal state management of MissionRegistryView.
 */
import React from 'react';
import type { MissionDetails } from '../../types';

// Re-export the MatchCandidate type used by this panel
export interface MatchCandidate {
    id: string;
    name: string;
    role: string;
    email: string;
    phone: string;
    location: string;
    linkedin: string;
    score: number;
    initials: string;
    skills: { name: string; type: string }[];
    summary: string;
    criteria: { label: string; status: string; proof: string }[];
    verifications: string[];
    interviewQuestions: string[];
}

export interface MissionDetailPanelProps {
    // The mission being viewed
    mission: MissionDetails;
    // All rendering is delegated to MissionRegistryView via render prop pattern
    renderContent: () => React.ReactNode;
}

/**
 * MissionDetailPanel wraps the full-page mission detail view.
 * The actual content is rendered by MissionRegistryView via the renderContent prop,
 * allowing the parent to keep its state management intact.
 */
const MissionDetailPanel: React.FC<MissionDetailPanelProps> = ({ mission, renderContent }) => {
    return (
        <>
            {renderContent()}
        </>
    );
};

export default MissionDetailPanel;
